export class NonnaRepository {
  async fetchFeaturedNonnas() {
    throw new Error('fetchFeaturedNonnas() must be implemented')
  }

  async fetchNonnaById(_id) {
    throw new Error('fetchNonnaById() must be implemented')
  }

  async fetchBookings(_parentId) {
    throw new Error('fetchBookings() must be implemented')
  }

  async createBooking(_draft, _parentId) {
    throw new Error('createBooking() must be implemented')
  }

  async fetchPaymentMethods(_parentId) {
    throw new Error('fetchPaymentMethods() must be implemented')
  }

  async fetchPaymentTransactions(_parentId) {
    throw new Error('fetchPaymentTransactions() must be implemented')
  }

  async fetchFAQEntries() {
    throw new Error('fetchFAQEntries() must be implemented')
  }
}